import { useQuery, useMutation } from "@tanstack/react-query";
import { fetchAllOrderPrintFormats } from "services/ordprintformat";

export const useAllOrderPrintFormats = (filters = {}) => {
  const query = useQuery({
    queryKey: ["all-orderprintformats", filters],
    queryFn: () => fetchAllOrderPrintFormats(filters),
  });
  return query;
};
